import { PrintBasicInfoTableLayout } from "../../../layout";

type Props = {
	guestName: string;
};

export const BasicInfoGuestNameOfPrintComposition = ({ guestName }: Props) => {
	return <PrintBasicInfoTableLayout title="お名前" content={guestName} />;
};
